import Header from "../components/Header";
import Footer from "../components/Footer";
import '../App.css';
import '../styles/Home.css';
import {useEffect} from "react";
import {preloadImages} from "../utils/preloadImages";

function Home() {
    useEffect(() => {
        preloadImages();
    }, []);
    return (
        <div className="page-wrapper">
            <Header />
            <div className="web-body">
            <div className="main">
                <img src="/images/Poolhouse/002.jpg" alt="Overkapping" />
                <div className="right-container">
                    <h1>Tuinplezier op maat</h1>
                    <h2>Welkom bij Bart Vandevenne</h2>
                    <p>Op zoek naar een tuinhuis, carport of poolhouse dat perfect past bij jouw stijl en buitenruimte? Dan zit je hier goed.</p>
                    <p>Wij bouwen alles op maat, met liefde voor hout en oog voor detail. Geen standaard werk, maar iets dat écht bij jou past.</p>
                    <p>Scroll gerust door onze realisaties, doe inspiratie op, en wie weet bouwen we binnenkort samen aan jouw tuinproject.</p>
                </div>
            </div>
                <div className="about-us">
                    <div className="left-container">
                        <h1>Over ons</h1>
                        <p>Bij ons draait alles om vakmanschap, maatwerk en een persoonlijke aanpak. Wij zijn een kleinschalig team met een grote passie voor hout en maatwerk. We bouwen tuinhuizen, carports, poolhouses, overkappingen en diverse andere werken die perfect aansluiten bij jouw wensen en stijl. Persoonlijke service en degelijk vakwerk: dat is waar we voor staan.</p>
                    </div>
                    <div className="right-container">
                    <div className="image-wrapper">
                        <img src="/images/Tuinhuizen/003.jpg" alt="Tuinhuis" />
                    </div>
                    </div>
                </div>
                <div className="diensten">
                    <div className="left-container">
                        <div className="image-wrapper">
                        <img src="/images/Carports/6.jpg" alt="Carport" />
                        </div>
                    </div>
                    <div className="right-container">
                        <h1>Bij ons kan u terecht voor:</h1>
                        <ul className="diensten-lijst">
                            <li>
                                <span className="icon"><span className="material-symbols-outlined">house</span></span>
                                <span><strong>Tuinhuizen</strong></span>
                            </li>
                            <li>
                                <span className="icon"><span className="material-symbols-outlined">directions_car</span></span>
                                <span><strong>Carports</strong></span>
                            </li>
                            <li>
                                <span className="icon"><span className="material-symbols-outlined">pool</span></span>
                                <span><strong>Poolhouse</strong></span>
                            </li>
                            <li>
                                <span className="icon"><span className="material-symbols-outlined">pergola</span></span>
                                <span><strong>Overkappingen</strong></span>
                            </li>
                            <li>
                            <span className="icon"><span className="material-symbols-outlined">outdoor_garden</span></span>
                                <span><strong>Diverse werken:</strong> Poorten, afsluitingen, …</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Home;
